import { Box, Typography } from '@mui/material';
import React from 'react';
import { getMoodColors } from '../../../../config/consts';
import { GraphPng } from '../../../../utils/graphUtil';

export const SemiCircularGaugeNew = ({ value, valueZ, label, subLabel, chemoName, type, width, height, isReport = false, isMiniReport = false }) => {
  return (
    <>
      {/* <div
        style={{
          position: 'relative',
          userSelect: 'none',
          marginTop: isReport ? '0px' : isMiniReport ? '10px' : '48px',
          marginBottom: isMiniReport ? '5px' : '24px'
        }}
      >
        <GraphPng value={value} chemoName={chemoName} type={type} width={width} height={height} />

        {!isReport && !isMiniReport && (<div style={{ position: 'absolute', top: '30%', left: type === 'Terpenes' ? '17.5%' : '17%', fontSize: '12px', fontFamily: 'Inter', fontWeight: '500' }}>{label}</div>)}

        {!isMiniReport && (<div style={{ position: 'absolute', top: isReport ? '34%' : '40%', left: isReport ? type === 'Terpenes' ? '35%' : '33%' : type === 'Terpenes' ? '17%' : '14%', fontSize: isReport ? '22px' : '38px', fontFamily: 'Space Grotesk', fontWeight: 700 }}>
          {type === 'Cannaboids' ? `${value}%` : `${value}%`}
        </div>)}
        {!isMiniReport && type !== 'Terpenes' && (<div style={{ position: 'absolute', top: isReport ? '60%' : '75%', left: isReport ? type === 'Terpenes' ? '32%' : '31%' : type === 'Terpenes' ? '17.5%' : '16%', fontSize: isReport ? '13px' : '16px', fontFamily: 'Inter', fontWeight: 700 }}>{subLabel}</div>)}
      </div> */}

      <Box
        sx={{
          position: 'relative',
          userSelect: 'none',
          marginTop: isReport ? '0px' : isMiniReport ? '10px' : '48px',
          marginBottom: isMiniReport ? '5px' : '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <GraphPng value={valueZ} chemoName={chemoName} type={type} width={width} height={height} />

        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            marginTop: isReport ? type !== 'Terpenes' ? 3 : 0 : type !== 'Terpenes' ? 6 : 3.5,
            textAlign: 'center',
          }}
        >
          {
            !isReport && !isMiniReport && (
              <div
                style={{
                  fontSize: '12px',
                  fontFamily: 'Inter',
                  fontWeight: '500'
                }}
              >
                {label}
              </div>
            )}

          {!isMiniReport && (
            <div
              style={{
                position: 'relative',
                fontSize: isReport ? '22px' : '38px',
                fontFamily: 'Space Grotesk',
                fontWeight: 700,
                top: -8
              }}
            >
              {type === 'Cannaboids' ? `${value}%` : `${value}%`}
            </div>
          )}

          {!isMiniReport && type !== 'Terpenes' && (
            <div
              style={{
                position: 'relative',
                fontSize: isReport ? '13px' : '16px',
                fontFamily: 'Inter',
                fontWeight: 700,
                top: -16
              }}>
              {subLabel}
            </div>
          )}
        </Box>

        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: isMiniReport ? '15px' : isReport ? '90px' : '150px',
            width: isMiniReport ? '40px' : isReport ? '200px' : '300px'
          }}
        >
          <Typography fontSize={isMiniReport ? '3px' : isReport ? '10px' : '12px'} fontFamily={'Inter'} fontWeight={500}>
            LOW
          </Typography>

          <Typography fontSize={isMiniReport ? '3px' : isReport ? '10px' : '12px'} fontFamily={'Inter'} fontWeight={500}>
            TYPICAL
          </Typography>

          <Typography fontSize={isMiniReport ? '3px' : isReport ? '10px' : '12px'} fontFamily={'Inter'} fontWeight={500}>
            HIGH
          </Typography>
        </Box>
      </Box>
    </>
  )
};

const SemiCircularGauge = ({ value, size = 200, label, subLabel, chemoName }) => {
  const strokeWidth = 10;
  const halfSize = size * 0.5;

  // Normalize the value to be between 0 and 100
  const normalizedValue = Math.min(Math.max(value, 20), 85);
  // change (1 - normalizedValue / 100) to (normalizedValue / 100) for inverting angles and starting 0degree from right
  const markerRotation = 180 * (1 - normalizedValue / 100);

  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: halfSize,
        userSelect: 'none',
        marginTop: '48px',
        marginBottom: '24px'
      }}
    >
      <svg height={halfSize}>
        <path
          d="M0.200678 105.449C-0.595951 107.676 1.08012 109.986 3.44562 109.986H3.60497C5.04458 109.986 6.33297 109.096 6.87464 107.763C27.9517 55.8617 78.8712 19.2639 138.339 19.2639C197.806 19.2639 248.725 55.8617 269.803 107.763C270.344 109.096 271.633 109.986 273.072 109.986H296.48C298.845 109.986 300.521 107.676 299.725 105.449C277.74 43.9814 218.987 0 149.963 0C80.9377 0 22.1853 43.9814 0.200678 105.449Z"
          fill="url(#paint0_linear_2143_18063)"
        />
        <defs>
          <linearGradient id="paint0_linear_2143_18063" x1="307.5" y1="110" x2="-11" y2="110" gradientUnits="userSpaceOnUse">
            <stop offset="0.375" />
            <stop offset="1" stopOpacity="0" />
          </linearGradient>
        </defs>
        {/* Marker */}
        <rect
          x={halfSize - strokeWidth / 2}
          y={strokeWidth - 25}
          width={20}
          height={50}
          fill={`${getMoodColors(chemoName).color}`}
          stroke="white"
          strokeWidth="4"
          transform={`rotate(${markerRotation - 90},${halfSize},${halfSize})`}
        />
      </svg>

      {/* Label */}
      <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', fontSize: '12px', fontFamily: 'Inter', fontWeight: '500' }}>{label}</div>

      {/* Text label */}
      <div style={{ position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '38px', fontFamily: 'Space Grotesk', fontWeight: 700 }}>
        {`${value}%`}
      </div>
      {/* Sub label */}
      <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', fontSize: '16px', fontFamily: 'Inter', fontWeight: 700 }}>{subLabel}</div>

      <div style={{ postion: 'absolute', transform: 'translate(93%, -170%)', fontSize: '14px', fontFamily: 'Inter', fontWeight: 700 }}>0%</div>
      <div style={{ postion: 'absolute', transform: 'translate(-5%, -260%)', fontSize: '14px', fontFamily: 'Inter', fontWeight: 700 }}>100%</div>
    </div>
  );
};

export const SemiCircularGaugeMiniReport = ({ value, size = 50, label, subLabel, chemoName }) => {
  const strokeWidth = 1;
  const halfSize = 20;

  // Normalize the value to be between 0 and 100
  const normalizedValue = Math.min(Math.max(value, 20), 85);
  // change (1 - normalizedValue / 100) to (normalizedValue / 100) for inverting angles and starting 0degree from right
  const markerRotation = 180 * (1 - normalizedValue / 100);

  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: halfSize,
        userSelect: 'none',
        marginTop: '10px',
        marginBottom: '5px'
      }}
    >
      <svg height={halfSize}>
        <path fillRule="evenodd" clipRule="evenodd" d="M0.0449777 13.0484C-0.129241 13.5152 0.224962 13.9999 0.723235 13.9999H1.39729C1.697 13.9999 1.96537 13.8176 2.08725 13.5438C4.55636 7.9973 10.2265 4.11762 16.8267 4.11762C23.4269 4.11762 29.0971 7.9973 31.5662 13.5438C31.6881 13.8176 31.9564 13.9999 32.2562 13.9999H36.9712C37.4695 13.9999 37.8237 13.5152 37.6495 13.0484C34.8053 5.42725 27.4601 0 18.8472 0C10.2344 0 2.88918 5.42725 0.0449777 13.0484Z" fill="url(#paint0_linear_3387_28940)" />
        <defs>
          <linearGradient id="paint0_linear_3387_28940" x1="40.9346" y1="29.0076" x2="-1.42999" y2="29.0076" gradientUnits="userSpaceOnUse">
            <stop offset="0.375" />
            <stop offset="1" stopOpacity="0" />
          </linearGradient>
        </defs>
        {/* Marker */}
        <rect
          x={14}
          y={0}
          width={4}
          height={8}
          fill={`${getMoodColors(chemoName).color}`}
          stroke="white"
          strokeWidth="2"
          transform={`rotate(${markerRotation - 90},${halfSize},${halfSize})`}
        />
      </svg>

      {/* Label */}
      {/* <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', fontSize: '12px' }}>{label}</div> */}

      {/* Text label */}
      {/* <div style={{ position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '38px' }}>
              {`${value}%`}
          </div> */}
      {/* Sub label */}
      {/* <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', fontSize: '16px' }}>{subLabel}</div> */}
    </div>
  );
};

export default SemiCircularGauge;
